import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import Tag from "../Tag/Tag";
import { ReactComponent as XIcon } from "../../../assets/icons/x.svg";
import placeholderImg from "../../../assets/img/gallery/placeholder.jpg";

import "./ShowOffField.scss";
import Image from "../Image/Image";

export const ShowOffFieldContainer = ({ children }) => (
  <div className="ShowOffFieldContainer">{children}</div>
);

export const LikeIcon = props => {
  return (
    <svg
      onClick={props.onClick}
      width={26}
      height={22}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
    >
      {!!props.isLiked === true && (
        <path
          d="M4.3314 12.0474L12 20L19.6686 12.0474C20.5211 11.1633 21 9.96429 21 8.71405C21 6.11055 18.9648 4 16.4543 4C15.2487 4 14.0925 4.49666 13.24 5.38071L12 6.66667L10.76 5.38071C9.90749 4.49666 8.75128 4 7.54569 4C5.03517 4 3 6.11055 3 8.71405C3 9.96429 3.47892 11.1633 4.3314 12.0474Z"
          stroke="#00965E"
          fill="#00965E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
      {!!props.isLiked === false && (
        <path
          d="M4.3314 12.0474L12 20L19.6686 12.0474C20.5211 11.1633 21 9.96429 21 8.71405C21 6.11055 18.9648 4 16.4543 4C15.2487 4 14.0925 4.49666 13.24 5.38071L12 6.66667L10.76 5.38071C9.90749 4.49666 8.75128 4 7.54569 4C5.03517 4 3 6.11055 3 8.71405C3 9.96429 3.47892 11.1633 4.3314 12.0474Z"
          stroke="#000000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
};

const ShowOffField = ({
  photo,
  index,
  author,
  description,
  imageUrl,
  isRewarded,
  isLiked,
  starsCount,
  tags,
  onVote,
  onClick,
  t,
  authorSlug,
  isEditMode,
  isDraft,
  onRemove,
  isRejected,
  onEdit,
}) => (
  <div className={`ShowOffField ${isEditMode ? "ShowOffField--edit" : ""}`}>
    <div className="ShowOffField__img" onClick={onClick}>
      <div className="ShowOffField__img__wrapper">
        <Image
          src={imageUrl || placeholderImg}
          alt=""
          width="auto"
          height="auto"
        />
        {isDraft && isEditMode && (
          <div className="ShowOffField__draft">
            <p>{t("widgets:photo.pendding")}</p>
          </div>
        )}
        {isRejected && isEditMode && (
          <div className="ShowOffField__rejected">
            <p>{t("widgets:photo.rejected")}</p>
          </div>
        )}
      </div>
      {isRewarded && (
        <div className="ShowOffField__rewarded">
          {t("widgets:photo.rewarded")}
        </div>
      )}
      {isEditMode && <p className="ShowOffField__description">{description}</p>}

      <div className="ShowOffField__tags">
        <div>
          {tags.slice(0, 4).map(({ name }) => (
            <Tag key={`tag-${name}`} label={name} />
          ))}
          {tags.length > 4 && (
            <span className="ShowOffField__tags__more">
              + {tags.length - 4} {t("widgets:photo.moreTags")}
            </span>
          )}
        </div>
      </div>
    </div>
    <div className="ShowOffField__content">
      {isEditMode ? (
        <button className="btn-remove" type="button" onClick={onRemove}>
          <XIcon /> {t("widgets:common.remove")}
        </button>
      ) : (
        <>
          <p className="ShowOffField__description">{description}</p>
          <a className="ShowOffField__author" href={`/galeria/${authorSlug}`}>
            <span>{t("widgets:photo.author")}:</span> {author}
          </a>
        </>
      )}
      {!isDraft && !isRejected && (
        <div className="ShowOffField__rating">
          <span>{starsCount}</span>
          <LikeIcon isLiked={isLiked} onClick={() => onVote(photo, index)} />
        </div>
      )}
      {isEditMode && isDraft && (
        <span className="ShowOffField__edit" onClick={onEdit}>
          {/* eslint-disable-next-line global-require */}
          <Image alt="edytuj" src={require("../../../assets/img/edit.png")} />
          {t("widgets:common.edit")}
        </span>
      )}
    </div>
  </div>
);

ShowOffField.propTypes = {
  isLiked: PropTypes.bool,
  isRewarded: PropTypes.bool,
  author: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  starsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onClick: PropTypes.func,
  isEditMode: PropTypes.bool,
};

ShowOffField.defaultProps = {
  isRewarded: false,
  isLiked: false,
  starsCount: 0,
  onClick: () => undefined,
  isEditMode: false,
};

export default withTranslation(["widgets"])(ShowOffField);
